export default __webpack_public_path__ + "static/media/flag-11.0178eee7.gif";